import { render, staticRenderFns } from "./contentCategory.vue?vue&type=template&id=139d82d2&scoped=true"
import script from "./contentCategory.vue?vue&type=script&lang=js"
export * from "./contentCategory.vue?vue&type=script&lang=js"
import style0 from "./contentCategory.vue?vue&type=style&index=0&id=139d82d2&prod&lang=css"
import style1 from "./contentCategory.vue?vue&type=style&index=1&id=139d82d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d82d2",
  null
  
)

export default component.exports